import { useBoolVariation } from '@launchdarkly/react-sdk';

const FEATURE_FLAG = ['show-build-info'] as const;

type FeatureFlagKey = (typeof FEATURE_FLAG)[number];

/**
 * Get flag value based on feature flag key. The root loader identifies the
 * session user (keyed by accountId, matching the A/B router's LD context)
 * before first render, so user targeting works in the shell.
 * @param flagKey from FEATURE_FLAG
 * @returns boolean
 */
const useFeatureFlag = (flagKey: FeatureFlagKey): boolean =>
    useBoolVariation(flagKey, false);

/** Whether to show the build stamp (env + commit) in the account menu. */
export const useShowBuildInfo = () => useFeatureFlag('show-build-info');
